import { render, staticRenderFns } from "./DashboardCosteo.vue?vue&type=template&id=6308ca74&scoped=true"
import script from "./DashboardCosteo.vue?vue&type=script&lang=js"
export * from "./DashboardCosteo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6308ca74",
  null
  
)

export default component.exports